// copy values from .env to window.config (if they exist)
if (import.meta.env.VITE_REMOTE_URL) window.config.front_url = import.meta.env.VITE_REMOTE_URL;
if (import.meta.env.VITE_TENANT_ID) window.config.clientId = import.meta.env.VITE_TENANT_ID;
if (import.meta.env.VITE_SITE_ID) window.config.siteId = import.meta.env.VITE_SITE_ID;

if (import.meta.env.VITE_ENABLE_LOCAL_JACKPOTS)
  window.config.enableLocalJackpots = import.meta.env.VITE_ENABLE_LOCAL_JACKPOTS === 'true' ? '1' : '';

if (import.meta.env.VITE_APP_PLATFORM) {
  if (import.meta.env.VITE_LOADER_URL) window.config.loaderImage = import.meta.env.VITE_LOADER_URL;
  if (import.meta.env.VITE_LOADER_TEXT) window.config.loaderText = import.meta.env.VITE_LOADER_TEXT;

  window.config.cordova = true;
  window.config.native_platform = import.meta.env.VITE_APP_PLATFORM;
}

if (import.meta.env.VITE_DEFAULT_LANGUAGE) window.config.defaultLanguage = import.meta.env.VITE_DEFAULT_LANGUAGE;


if (import.meta.env.VITE_SPORT_BETS_URL_ROOT) window.config.sportBetsUrlRoot = import.meta.env.VITE_SPORT_BETS_URL_ROOT;
if (import.meta.env.VITE_DISABLE_IN_PAGE_MATCH_DETAILS)
  window.config.disableInPageMatchDetails = import.meta.env.VITE_DISABLE_IN_PAGE_MATCH_DETAILS;

//DO NOT REMOVE - This is related to the popup switch
// check if newsite cookie is set
if (!document.cookie.includes('newsite=yes; expires')) {
  // get domain without www and subdomains
  // let domain = window.location.hostname.replace('www.', '');
  // domain = domain.split('.');
  // domain = domain[domain.length - 2] + '.' + domain[domain.length - 1];
  document.cookie = 'newsite=yes; expires=Tue, 01 Jan 2069 12:00:00 UTC;path=/';
}

const removeMeta = () => {
  try {
    document.querySelector('head>title').remove();
  } catch (e) { }

  const metas = [
    'description',
    'og:description',
    'twitter:description',
    'keywords',
    'og:keywords',
    'twitter:keywords',
    'og:site_name',
    'twitter:site',
    'twitter:creator',
    'og:image',
    'twitter:image',
    'og:image:width',
    'og:image:height',
    'og:image:alt',
    'twitter:image:alt',
    'og:type',
    'og:locale',
    'og:locale:alternate',
    'og:video',
    'og:video:width',
    'og:video:height',
    'og:video:type',
    'og:video:alt',
    'twitter:card',
    'thumbnail',
    'og:title',
  ];

  metas.forEach((meta) => {
    try {
      document.querySelector(`meta[property="${meta}"]`).remove();
    } catch (e) { }
  });

  const links = ['canonical', 'og:url', 'twitter:url'];

  links.forEach((meta) => {
    try {
      document.querySelector(`link[rel="${meta}"]`).remove();
    } catch (e) { }
  });
};
removeMeta();

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

if (urlParams.has('appEnv') && urlParams.get('appEnv') === 'flutter') {
  // mobile app
  window.config.appEnv = 'flutter'; // used in tmpls: eko-mobile-page-header, mobile-page-header
  window.config.disableCookies = '1';

  // disable all the stuff that isn't needed in the mobile app when launching a game
  if (location.href.includes('/slot-game/') || location.href.includes('/live-game/')) {
    window.config.betBuilderEnable = 0;
    window.config.betsEnabled = 0;
    window.config.lottoEnabled = 0;
    window.config.promoCalendarEnabled = 0;
    window.config.winnerFunEnabled = 0;
  }

  document.documentElement.classList.add('flutter');

  if (urlParams.has('platformType')) {
    const platformType = urlParams.get('platformType');
    if (['1', '2', '3', '4', '5'].includes(platformType)) {
      window.config.platformType = platformType;
    }
  }
}

if (urlParams.has('appEnv') && urlParams.get('appEnv') === 'wrapper-mobile') {
  // generic mobile app
  window.config.appEnv = 'wrapper-mobile';
  document.documentElement.classList.add('wrapper-mobile');

  if (urlParams.has('disableCookiesAgreement')) {
    window.config.disableCookies = '1';
  }

  if (urlParams.has('platformType')) {
    const platformType = urlParams.get('platformType');
    if (['1', '2', '3', '4', '5'].includes(platformType)) {
      window.config.platformType = platformType;
    }
  }
}

if (urlParams.has('SourceSubBrand') && urlParams.get('SourceSubBrand') === '168') {
  // poker app
  window.config.appEnv = 'poker';
  window.config.disableCookies = '1';
  document.documentElement.classList.add('poker');

  localStorage.removeItem('access_token');
  localStorage.removeItem('token_type');
  localStorage.removeItem('auth_type');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('expires_in');
  localStorage.removeItem('auth_date');

  if (urlParams.has('SourceProductPackage')) {
    let platformType = urlParams.get('SourceProductPackage');
    if (['6', '41', '122', '126'].includes(platformType)) {
      switch (platformType) {
        case '6':
        case '41':
          platformType = '1';
          break;
        case '122':
          platformType = '3';
          break;
        case '126':
          platformType = '4';
          break;
      }

      window.config.platformType = platformType;
    }
  }
}

if (window.config.appEnv === 'flutter' || window.config.appEnv === 'poker') {
  let originalHeight = document.scrollingElement.scrollHeight;
  window.parent.postMessage({ type: 'resize', data: { height: originalHeight } }, '*');

  const resizeObserver = () => {
    if (originalHeight === document.scrollingElement.scrollHeight) return;
    //console.log('Body height changed:', document.scrollingElement.scrollHeight);

    originalHeight = document.scrollingElement.scrollHeight;
    window.parent.postMessage({ type: 'resize', data: { height: originalHeight } }, '*');
  };

  setInterval(resizeObserver, 1000);
}

if (urlParams.has('dsic') && urlParams.get('dsic') === '1') {
  window.config.addDesignSystemIframeClient = true;
}

const getLanguageCode = (lang) => {
  if (window.config.appEnv === 'poker') {
    const langs = {
      ENG: 'en',
      RUM: 'ro',
    };
    lang = langs[lang];
  }

  if (lang && window.config.languages.includes(lang)) {
    return lang;
  } else {
    return false;
  }
};

const languageParams = ['lng', 'lang', 'LangID'];

for (const lang in languageParams) {
  if (urlParams.has(languageParams[lang])) {
    let lng = getLanguageCode(urlParams.get(languageParams[lang]));
    if (lng) {
      try {
        window.config.defaultLanguage = lng; // this is used in i18next initialization. helps us with force language change
        localStorage.setItem('i18nextLng', lng); // this is used in i18next initialization. helps us with force language change
        break; // exit loop if language is set
      } catch (e) {}
    }
  }
}

const jsonDecodeConfig = () => {
  const toDecode = ['depositSettings', 'withdrawSettings'];
  toDecode.forEach((key) => {
    try {
      if (window?.config?.[key]) {
        window.config[key] = JSON.parse(window.config[key]);
      }
    } catch (e) {
      // do nothing;
    }
  });
};
jsonDecodeConfig();

if (navigator?.userAgent?.includes?.('https://github.com/prerender/prerender')) {
  window.config.disableCookies = '1';
  window.config.inPrerender = true;
}

